<template>
  <full-reduction-promotion-details :is-edit='true'>
  </full-reduction-promotion-details>
</template>

<script>
import FullReductionPromotionDetails from '../FullReductionPromotionDetails'
export default {
  name: 'EditFullReductionPromotion',
  components: {
    FullReductionPromotionDetails
  }
}
</script>
